/**
 * @file
 * Subnavigation functionality.
 */

((Drupal, once) => {
  let _$subnavigation = null;
  let _hideTimer = null;
  let _$hoveredMenuItem = null;

  /**
   * Show subnavigation block.
   */
  function showSubnavigation() {
    if (_$subnavigation !== null) {
      clearTimeout(_hideTimer);
      _$subnavigation.classList.add('active');
    }
  }

  /**
   * Hide subnavigation block.
   */
  function hideSubnavigation() {
    if (_$subnavigation !== null) {
      _$subnavigation.classList.remove('active');
      _$subnavigation = null;

      // Remove hovered state on menu item.
      _$hoveredMenuItem.classList.remove('hovered');
    }
  }

  /**
   * Timed hide subnavigation block.
   */
  function timedSubnavigationClose() {
    clearTimeout(_hideTimer);
    _hideTimer = setTimeout(hideSubnavigation, 250);
  }

  /**
   * Check if menu item has subnavigation block.
   *
   * @param e
   * @param props
   */
  function checkForCorrespondingSubnavigation(e, props) {
    // Hide subnavigation if one's active.
    hideSubnavigation();

    // Set subnavigation connected to hover item.
    const _$parent = props._$trigger.parentElement;
    const _subnavigationId = _$parent.getAttribute('data-menu-item-id');
    _$subnavigation = document.body.querySelector('[data-subnavigation-id="' + _subnavigationId + '"]');

    // If subnavigation is not null, show it.
    if (_$subnavigation !== null) {
      // Set menu item being hovered and add hovered state on it.
      _$hoveredMenuItem = e.target;
      _$hoveredMenuItem.classList.add('hovered');

      showSubnavigation();

      // Add hover events for subnavigation itself.
      _$subnavigation.addEventListener('mouseover', showSubnavigation);
      _$subnavigation.addEventListener('mouseleave', hideSubnavigation);
    }
  }

  /**
   * Initialize subnavigation.
   *
   * @param props
   */
  function init(props) {
    props._$trigger.addEventListener('mouseenter', (e) => {
      checkForCorrespondingSubnavigation(e, props);
    });

    props._$trigger.addEventListener('mouseleave', () => {
      timedSubnavigationClose();
    });
  }

  Drupal.behaviors.subnavigation = {
    attach(context) {
      const _$triggers = once('trigger', '[data-menu-item-trigger] > a', context);

      // If there are trigger.s
      if (_$triggers) {
        _$triggers.forEach(_$trigger => {
          init({_$trigger});
        });
      }
    }
  };
})(Drupal, once);
